import React, {
  useEffect,
  ChangeEvent,
  Dispatch,
  SetStateAction,
  useState,
} from 'react';
import { injectIntl, IntlShape } from 'react-intl';
import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider,
} from '@material-ui/pickers';
import { isEmpty, uniqueId, get, orderBy, isNil } from 'lodash';
import DateFnsUtils from '@date-io/date-fns';
import frLocale from 'date-fns/locale/fr';
import {
  Checkbox,
  FormControlLabel,
  FormGroup,
  Button,
} from '@material-ui/core';
import {
  TextField,
  Grid,
  FormControl,
  Select,
  InputLabel,
  MenuItem,
  FormHelperText,
} from '@material-ui/core';
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';
import moment from 'moment-timezone';
import messages from 'containers/LawyerLegalProceedingsPage/CivilProceeding/messages';
import { FormContainer } from 'containers/CourtManagerLegalProceedings/styled-components';
import { LABEL_WIDTH } from 'containers/common/LegalProceedings/JudgementAdd/Forms/ProcedureInformation/constants';
import {
  CIVIL_PROCEEDING_LAWYER_INFORMATIONS_FIELDS,
  EMPTY_CIVIL_PROCEEDING_INFO_FIELDS,
  EMPTY_DOCUMENT,
} from 'containers/data-structure';
import { translate } from 'containers/services/translate';
import {
  DOC_ID_REQUEST,
  DOC_ID_CITATION,
} from 'containers/CourtManagerLegalProceedings/constants';
import { dateStringToLocalDate } from 'containers/IdentificationPage/utils';
import { DATE_FORMAT, DOCUMENT_TYPES } from 'constants/global';
import UploadDocumentBloc from 'containers/common/LegalProceedings/JudgementAdd/Forms/JudgementAddPrononcings/UploadDocumentBloc';
import { IUploadedDocument } from 'containers/LawyerLegalProceedingsPage/typings';
import { CivilProceedingDoc } from 'containers/CourtManagerLegalProceedings/constants';
import { CorporealDocument } from 'containers/common/LegalProceedings/JudgementAdd/Forms/JudgementAddPrononcings/typings';
import VictimCard from 'containers/CourtManagerLegalProceedings/victimCard';
import { Config } from 'containers/AppContainer/typings';
import CustomBloc from 'components/CustomBloc';
import RequestIcon from 'components/SahamIcons/RequestIcon';
import VictimIcon from 'components/SahamIcons/VictimIcon';
import VehicleCard from 'containers/CourtManagerLegalProceedings/VehicleCard';
import {
  VehicleForm,
  DamageType,
  OtherDamage,
  ClaimType,
} from 'containers/CourtManagerLegalProceedings/typings';
import * as featureService from 'features/fflip-helpers';
import { FEATURES } from 'features/features';
import {
  addDaysToDate,
  validationCourtFileNumber,
} from 'containers/common/LegalProceedings/JudgementAdd/Forms/ProcedureInformation/utils';
import { getDateIgnoreTimezone } from 'containers/common/LegalProceedings/utils';
import { getVictimFromSagisInfo } from 'containers/PreOpeningPage/utils';
import { getVehicleFromSagisInfo } from 'containers/PreOpeningPage/OpposingParty/utils';
import { VictimType } from 'typings/globalTypes';
import { ClaimRecapType } from 'typings/claimTypes';
export interface CivilProceedingFormProps {
  intl: IntlShape;
  resetUploadedDocument: Function;
  uploadDocument: Function;
  uploadedDocument: IUploadedDocument;
  documentId: string;
  setDocumentId: Function;
  victims: any;
  vehicles: any;
  listings: any;
  requestCorporealLawyers: Function;
  corporealLawyers: any;
  civilProceedingDoc: any;
  setCivilProceedingDoc: Function;
  civilProceedingInfo: any;
  setCivilProceedingInfo: Function;
  setVictimsInfo: Function;
  victimsInfo: any;
  claimId: number;
  damage: DamageType;
  lossDate: string;
  setDamage: Dispatch<SetStateAction<DamageType>>;
  claimType: ClaimType;
  setClaimType: Dispatch<SetStateAction<ClaimType>>;
  otherDamage: OtherDamage;
  handleChangeOtherDamage: (e: React.ChangeEvent<HTMLInputElement>) => void;
  vehicleFormValues: { [key: string]: VehicleForm };
  setVehicleFormValues: Dispatch<
    SetStateAction<{ [key: string]: VehicleForm }>
  >;
  addVehicleForm: () => void;
  victimFormValues: { [key: string]: VictimType };
  setVictimFormValues: Dispatch<SetStateAction<{ [key: string]: VictimType }>>;
  addVictimForm: () => void;
  associatedVictims: any[];
  setAssociatedVictims: Dispatch<SetStateAction<any[]>>;
  associatedOpposingParties: any[];
  setAssociatedOpposingParties: Dispatch<SetStateAction<any[]>>;
  victimValidation?: any;
  sagisVictimInfo: any;
  sagisOpposingParties: any;
  claimRecap: ClaimRecapType;
}
const CivilProceedingForm: React.FC<CivilProceedingFormProps> = (
  props,
): JSX.Element => {
  const [errorDate, setErrorDate] = useState(false);

  const {
    damage,
    setDamage,
    claimType,
    setClaimType,
    otherDamage,
    handleChangeOtherDamage,
    vehicleFormValues,
    setVehicleFormValues,
    addVehicleForm,
    victimFormValues,
    setVictimFormValues,
    addVictimForm,
    associatedVictims,
    setAssociatedVictims,
    associatedOpposingParties,
    setAssociatedOpposingParties,
  } = props;
  useEffect(() => {
    if (!isNil(get(props.civilProceedingInfo, 'id'))) {
      setCivilProceedingInfo(props.civilProceedingInfo);
    }
  }, [props.civilProceedingInfo]);

  const [civilProceedingInfo, setCivilProceedingInfo] = useState({
    ...EMPTY_CIVIL_PROCEEDING_INFO_FIELDS,
  });

  const [civilProceedingInfoDoc, setCivilProceedingInfoDoc] = useState<
    CivilProceedingDoc
  >({
    ...EMPTY_DOCUMENT,
  });
  const [civilProceedingRequestDoc, setCivilProceedingRequestDoc] = useState<
    CivilProceedingDoc
  >({
    ...EMPTY_DOCUMENT,
  });

  const setOneFormValuesVehicle = (id: string) => (
    newVehicleFormValue: VehicleForm,
  ) => {
    setVehicleFormValues(prevVehicleFormValues => ({
      ...prevVehicleFormValues,
      [id]: newVehicleFormValue,
    }));
  };

  const setOneFormValuesVictim = (id: string) => (
    newVictimFormValue: VictimType,
  ) => {
    setVictimFormValues(
      prevVictimFormValues =>
        ({
          ...prevVictimFormValues,
          [id]: newVictimFormValue,
        } as any),
    );
  };

  const handleChangeDate = (date: Date | null) => {
    const theDate = getDateIgnoreTimezone(date);
    const receiptRequestDate = moment(theDate as Date).format(DATE_FORMAT);
    props.setCivilProceedingInfo({
      ...props.civilProceedingInfo,
      receptionDate: receiptRequestDate,
    });
    setCivilProceedingInfo({
      ...civilProceedingInfo,
      dateReceiptRequest: receiptRequestDate,
    });
  };

  const handleChange = (field: string) => (
    event: React.ChangeEvent<{ name?: string | undefined; value: any }>,
  ) => {
    props.setCivilProceedingInfo({
      ...props.civilProceedingInfo,
      [field]: event.target.value,
    });
    setCivilProceedingInfo({
      ...civilProceedingInfo,
      [field]: event.target.value,
    });
  };

  const handleClaimTypeCheckboxClick = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    setClaimType(prevClaimType => ({
      ...prevClaimType,
      [event.target.name]: event.target.checked,
    }));
  };

  const handleDamageCheckboxClick = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    setDamage(prevClaimType => ({
      ...prevClaimType,
      [event.target.name]: event.target.checked,
    }));
  };

  const handleChangeDateHearing = (date: Date | null) => {
    const theDate = getDateIgnoreTimezone(date);
    setErrorDate(false);
    const hearing = moment(theDate as Date).format(DATE_FORMAT);
    props.setCivilProceedingInfo({
      ...props.civilProceedingInfo,
      hearingDate: hearing,
    });
    setCivilProceedingInfo({
      ...civilProceedingInfo,
      hearingDate: hearing,
    });
    if (addDaysToDate(props.lossDate || '', 1)) {
      if (
        //@ts-ignore
        new Date(addDaysToDate(props.lossDate || '', 1)) > new Date(hearing)
      ) {
        setErrorDate(true);
      }
    }
  };

  const setDocumentID = (document: CorporealDocument) => {
    let civilDoc = [...props.civilProceedingDoc];
    if (DOC_ID_REQUEST === props.documentId) {
      setCivilProceedingRequestDoc({
        name: document.name,
        type: document.type,
        url: document.url,
      });
      civilDoc.push({
        name: document.name,
        type: document.type,
        url: document.url,
      });
      props.setCivilProceedingDoc(civilDoc);
      props.resetUploadedDocument();
    }
  };

  const setDocumentCivilProceeding = (document: CorporealDocument) => {
    let civilDoc = [...props.civilProceedingDoc];
    if (DOC_ID_CITATION === props.documentId) {
      setCivilProceedingInfoDoc({
        name: document.name,
        type: document.type,
        url: document.url,
      });
      civilDoc.push({
        name: document.name,
        type: document.type,
        url: document.url,
      });
      props.setCivilProceedingDoc(civilDoc);
      props.resetUploadedDocument();
    }
  };

  const handleCheckVictim = (event: ChangeEvent<HTMLInputElement>) => {
    let newAssociatedVictims = [...associatedVictims];
    const newValue = parseInt(event.target.value);
    if (!associatedVictims.includes(newValue)) {
      newAssociatedVictims = [...associatedVictims, newValue];
    } else {
      newAssociatedVictims.splice(associatedVictims.indexOf(newValue), 1);
    }
    setAssociatedVictims(newAssociatedVictims);
  };

  const isCheckedVictim = (victimId: number) => {
    return associatedVictims.includes(victimId);
  };

  const handleCheckOpposingParty = (
    event: ChangeEvent<HTMLInputElement>,
    checked: boolean,
  ) => {
    let newAssociatedOpposingParties = [...associatedOpposingParties];
    const newValue = parseInt(event.target.value);
    if (!associatedOpposingParties.includes(newValue)) {
      newAssociatedOpposingParties = [...associatedOpposingParties, newValue];
    } else {
      newAssociatedOpposingParties.splice(
        associatedOpposingParties.indexOf(newValue),
        1,
      );
    }
    setAssociatedOpposingParties(newAssociatedOpposingParties);
  };

  const isCheckedOpposingParty = (opporsingPartyId: number) => {
    return associatedOpposingParties.includes(opporsingPartyId);
  };

  return (
    <FormContainer>
      <Grid container direction="column" spacing={2}>
        <CustomBloc
          title={translate(messages.basicInformation, props)}
          icon={<RequestIcon width="19" height="25" />}
        >
          <Grid container direction="row" spacing={2}>
            <Grid item xs={3}>
              <TextField
                id="judgement_number_field"
                label={translate(messages.opposingLawyerField, props)}
                onChange={handleChange(
                  CIVIL_PROCEEDING_LAWYER_INFORMATIONS_FIELDS.OPPOSING_LAWYER,
                )}
                className="input"
                name={
                  CIVIL_PROCEEDING_LAWYER_INFORMATIONS_FIELDS.OPPOSING_LAWYER
                }
                value={get(civilProceedingInfo, [
                  CIVIL_PROCEEDING_LAWYER_INFORMATIONS_FIELDS.OPPOSING_LAWYER,
                ])}
              />
            </Grid>
            <Grid item xs={3}>
              <FormControl className="input">
                <InputLabel id="idd-label-id">
                  {translate(messages.town, props)}
                </InputLabel>
                <Select
                  labelId="idd-label-id"
                  onChange={handleChange(
                    CIVIL_PROCEEDING_LAWYER_INFORMATIONS_FIELDS.TOWN,
                  )}
                  name={CIVIL_PROCEEDING_LAWYER_INFORMATIONS_FIELDS.TOWN}
                  value={get(civilProceedingInfo, [
                    CIVIL_PROCEEDING_LAWYER_INFORMATIONS_FIELDS.TOWN,
                  ])}
                  labelWidth={LABEL_WIDTH}
                  error={
                    featureService.hasFeature(
                      FEATURES.ASSIGNEMENT_JURISDICTION_LAWYER_REQUEST,
                    ) &&
                    isNil(
                      get(
                        civilProceedingInfo,
                        [CIVIL_PROCEEDING_LAWYER_INFORMATIONS_FIELDS.TOWN],
                        null,
                      ),
                    )
                  }
                >
                  {!isEmpty(props.listings.jurisdiction) &&
                    orderBy(
                      get(props.listings, 'jurisdiction', []),
                      [el => el?.title?.toLowerCase()],
                      ['asc'],
                    ).map((el: Config) => (
                      <MenuItem key={el.id} value={el.id}>
                        {el.title}
                      </MenuItem>
                    ))}
                </Select>
                {featureService.hasFeature(
                  FEATURES.ASSIGNEMENT_JURISDICTION_LAWYER_REQUEST,
                ) &&
                  isNil(
                    get(
                      civilProceedingInfo,
                      [CIVIL_PROCEEDING_LAWYER_INFORMATIONS_FIELDS.TOWN],
                      null,
                    ),
                  ) && (
                    <FormHelperText className="errorSelect">
                      {translate(messages.validateRequiredField, props)}
                    </FormHelperText>
                  )}
              </FormControl>
            </Grid>
            <Grid item xs={3}>
              <TextField
                id="judgement_number_field"
                label={translate(messages.courtNumber, props)}
                onChange={handleChange(
                  CIVIL_PROCEEDING_LAWYER_INFORMATIONS_FIELDS.COURT_NUMBER,
                )}
                className="input"
                name={CIVIL_PROCEEDING_LAWYER_INFORMATIONS_FIELDS.COURT_NUMBER}
                value={get(civilProceedingInfo, [
                  CIVIL_PROCEEDING_LAWYER_INFORMATIONS_FIELDS.COURT_NUMBER,
                ])}
                placeholder={'NNNNNN/NNNN/NNNN'}
                error={
                  !validationCourtFileNumber(
                    get(civilProceedingInfo, [
                      CIVIL_PROCEEDING_LAWYER_INFORMATIONS_FIELDS.COURT_NUMBER,
                    ]),
                  )
                }
                helperText={
                  !validationCourtFileNumber(
                    get(civilProceedingInfo, [
                      CIVIL_PROCEEDING_LAWYER_INFORMATIONS_FIELDS.COURT_NUMBER,
                    ]),
                  )
                    ? translate(messages.courtFileNumberError, props)
                    : ''
                }
              />
            </Grid>
            <Grid item xs={3}>
              <MuiPickersUtilsProvider utils={DateFnsUtils} locale={frLocale}>
                <KeyboardDatePicker
                  autoOk
                  variant="inline"
                  invalidDateMessage={
                    '' // add error
                  }
                  format="dd/MM/yyyy"
                  id="date-picker-inline-victim-date-of-birth"
                  label={translate(
                    { ...messages.dateReceiptRequestField },
                    props,
                  )}
                  className="input"
                  name={
                    CIVIL_PROCEEDING_LAWYER_INFORMATIONS_FIELDS.DATE_RECEIPT_REQUEST
                  }
                  value={dateStringToLocalDate(
                    get(
                      civilProceedingInfo,
                      [
                        CIVIL_PROCEEDING_LAWYER_INFORMATIONS_FIELDS.DATE_RECEIPT_REQUEST,
                      ],
                      '',
                    ) as any,
                  )}
                  onChange={handleChangeDate}
                  error={
                    dateStringToLocalDate(
                      get(
                        civilProceedingInfo,
                        [
                          CIVIL_PROCEEDING_LAWYER_INFORMATIONS_FIELDS.DATE_RECEIPT_REQUEST,
                        ],
                        '',
                      ) as any,
                    ) === 'Invalid date'
                  }
                  helperText={
                    dateStringToLocalDate(
                      get(
                        civilProceedingInfo,
                        [
                          CIVIL_PROCEEDING_LAWYER_INFORMATIONS_FIELDS.DATE_RECEIPT_REQUEST,
                        ],
                        '',
                      ) as any,
                    ) === 'Invalid date' &&
                    translate(messages.invalidDate, props)
                  }
                />
              </MuiPickersUtilsProvider>
            </Grid>
          </Grid>
        </CustomBloc>
        <CustomBloc
          icon={<RequestIcon width="19" height="25" />}
          title={translate(messages.damageAffectedByTheProcedure, props)}
        >
          <FormControl>
            <FormGroup>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={claimType.corporeal}
                    onChange={handleClaimTypeCheckboxClick}
                    name="corporeal"
                    color="primary"
                  />
                }
                label={translate(messages.corporeal, props)}
              />
            </FormGroup>
          </FormControl>
          <br />
          {claimType.corporeal && (
            <CustomBloc
              icon={<VictimIcon width="19" height="25" />}
              title={translate(messages.victimsTitle, props)}
              marginLeft
              rightButton={
                <Button onClick={addVictimForm}>
                  <AddCircleOutlineIcon className="icon" />
                  <div className="title-button">
                    {translate({ ...messages.addVictim }, props)}
                  </div>
                </Button>
              }
            >
              <div className="check_box_container">
                {!isEmpty(props.victims) &&
                  props.victims.map(
                    (victim: { id: number; firstName: any; lastName: any }) => (
                      <FormGroup key={uniqueId()} className="check_box_div">
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={isCheckedVictim(victim.id)}
                              name={
                                featureService.hasFeature(
                                  FEATURES.MIGRATION_CLAIM_INFO,
                                ) &&
                                !isEmpty(
                                  getVictimFromSagisInfo(
                                    get(victim, 'victimKey'),
                                    props.sagisVictimInfo,
                                  ),
                                )
                                  ? `${get(
                                      getVictimFromSagisInfo(
                                        get(victim, 'victimKey'),
                                        props.sagisVictimInfo,
                                      ),
                                      'victimFirstName',
                                      '',
                                    )} ${get(
                                      getVictimFromSagisInfo(
                                        get(victim, 'victimKey'),
                                        props.sagisVictimInfo,
                                      ),
                                      'victimLastName',
                                      '',
                                    )}`
                                  : `${victim.firstName} ${victim.lastName}`
                              }
                              color="primary"
                              value={victim.id}
                              onChange={handleCheckVictim}
                            />
                          }
                          label={
                            featureService.hasFeature(
                              FEATURES.MIGRATION_CLAIM_INFO,
                            ) &&
                            !isEmpty(
                              getVictimFromSagisInfo(
                                get(victim, 'victimKey'),
                                props.sagisVictimInfo,
                              ),
                            )
                              ? `${get(
                                  getVictimFromSagisInfo(
                                    get(victim, 'victimKey'),
                                    props.sagisVictimInfo,
                                  ),
                                  'victimFirstName',
                                  '',
                                )} ${get(
                                  getVictimFromSagisInfo(
                                    get(victim, 'victimKey'),
                                    props.sagisVictimInfo,
                                  ),
                                  'victimLastName',
                                  '',
                                )}`
                              : `${victim.firstName} ${victim.lastName}`
                          }
                        />
                      </FormGroup>
                    ),
                  )}
              </div>
              {Object.values(victimFormValues).length > 0 &&
                Object.keys(
                  victimFormValues,
                ).map((key: string, index: number) => (
                  <VictimCard
                    nbr={index + 1}
                    listings={props.listings}
                    formValues={victimFormValues[key]}
                    setFormValues={setOneFormValuesVictim(key)}
                    victimValidation={props.victimValidation}
                    claimRecap={props.claimRecap}
                  />
                ))}
            </CustomBloc>
          )}
          <FormControl>
            <FormGroup>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={claimType.material}
                    onChange={handleClaimTypeCheckboxClick}
                    name="material"
                    color="primary"
                  />
                }
                label={translate(messages.material, props)}
              />
            </FormGroup>
          </FormControl>
          <br />
          {claimType.material && (
            <div style={{ marginLeft: '40px' }}>
              <FormControl>
                <FormGroup>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={damage.adverseVehicles}
                        onChange={handleDamageCheckboxClick}
                        name="adverseVehicles"
                        color="primary"
                      />
                    }
                    label={translate(messages.adverseVehicles, props)}
                  />
                </FormGroup>
              </FormControl>
              <br />
              {damage.adverseVehicles && (
                <CustomBloc
                  icon={<RequestIcon width="19" height="25" />}
                  title={translate(messages.opposingParties, props)}
                  marginLeft
                  rightButton={
                    <Button onClick={addVehicleForm}>
                      <AddCircleOutlineIcon className="icon" />
                      <div className="title-button">
                        {translate({ ...messages.addOpposingParty }, props)}
                      </div>
                    </Button>
                  }
                >
                  <Grid container direction="row" spacing={2}>
                    <div className="check_box_container">
                      {!isEmpty(props.vehicles) &&
                        props.vehicles.map(
                          (vehicle: {
                            id: number;
                            firstName: any;
                            lastName: any;
                          }) => (
                            <FormGroup
                              key={uniqueId()}
                              className="check_box_div"
                            >
                              <FormControlLabel
                                control={
                                  <Checkbox
                                    checked={isCheckedOpposingParty(vehicle.id)}
                                    name={
                                      featureService.hasFeature(
                                        FEATURES.MIGRATION_CLAIM_INFO,
                                      ) &&
                                      !isEmpty(
                                        getVehicleFromSagisInfo(
                                          get(vehicle, 'partKey'),
                                          props.sagisOpposingParties,
                                        ),
                                      )
                                        ? get(
                                            getVehicleFromSagisInfo(
                                              get(vehicle, 'partKey'),
                                              props.sagisOpposingParties,
                                            ),
                                            'lastName',
                                          ) +
                                          ' ' +
                                          get(
                                            getVehicleFromSagisInfo(
                                              get(vehicle, 'partKey'),
                                              props.sagisOpposingParties,
                                            ),
                                            'firstName',
                                          )
                                        : `${vehicle.firstName} ${vehicle.lastName}`
                                    }
                                    value={vehicle.id}
                                    color="primary"
                                    onChange={handleCheckOpposingParty}
                                  />
                                }
                                label={
                                  featureService.hasFeature(
                                    FEATURES.MIGRATION_CLAIM_INFO,
                                  ) &&
                                  !isEmpty(
                                    getVehicleFromSagisInfo(
                                      get(vehicle, 'partKey'),
                                      props.sagisOpposingParties,
                                    ),
                                  )
                                    ? get(
                                        getVehicleFromSagisInfo(
                                          get(vehicle, 'partKey'),
                                          props.sagisOpposingParties,
                                        ),
                                        'lastName',
                                      ) +
                                      ' ' +
                                      get(
                                        getVehicleFromSagisInfo(
                                          get(vehicle, 'partKey'),
                                          props.sagisOpposingParties,
                                        ),
                                        'firstName',
                                      )
                                    : `${vehicle.firstName} ${vehicle.lastName}`
                                }
                              />
                            </FormGroup>
                          ),
                        )}
                    </div>
                  </Grid>
                  {Object.values(vehicleFormValues).length > 0 &&
                    Object.keys(
                      vehicleFormValues,
                    ).map((key: string, index: number) => (
                      <VehicleCard
                        nbr={index + 1}
                        listings={props.listings}
                        formValues={vehicleFormValues[key]}
                        setFormValues={setOneFormValuesVehicle(key)}
                      />
                    ))}
                </CustomBloc>
              )}
              <FormControl>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={damage.otherProperties}
                      onChange={handleDamageCheckboxClick}
                      name="otherProperties"
                      color="primary"
                    />
                  }
                  label={translate(messages.otherProperties, props)}
                />
              </FormControl>
              <br />
              {claimType.material && damage.otherProperties && (
                <TextField
                  label="description"
                  value={otherDamage.description}
                  onChange={handleChangeOtherDamage}
                />
              )}
            </div>
          )}
        </CustomBloc>
        <CustomBloc
          icon={<RequestIcon width="19" height="25" />}
          title={translate(messages.audience, props)}
        >
          <Grid container direction="row" spacing={2}>
            <Grid item xs={4}>
              <MuiPickersUtilsProvider utils={DateFnsUtils} locale={frLocale}>
                <KeyboardDatePicker
                  autoOk
                  variant="inline"
                  minDate={addDaysToDate(props.lossDate, 1)}
                  invalidDateMessage={
                    '' // add error
                  }
                  format="dd/MM/yyyy"
                  id="date-picker-inline-victim-date-of-birth"
                  label={translate({ ...messages.hearingDateField }, props)}
                  className="input"
                  name={
                    CIVIL_PROCEEDING_LAWYER_INFORMATIONS_FIELDS.HEARING_DATE
                  }
                  value={dateStringToLocalDate(
                    get(civilProceedingInfo, [
                      CIVIL_PROCEEDING_LAWYER_INFORMATIONS_FIELDS.HEARING_DATE,
                    ]) as any,
                  )}
                  onChange={handleChangeDateHearing}
                  error={
                    errorDate ||
                    dateStringToLocalDate(
                      get(civilProceedingInfo, [
                        CIVIL_PROCEEDING_LAWYER_INFORMATIONS_FIELDS.HEARING_DATE,
                      ]) as any,
                    ) === 'Invalid date'
                  }
                  helperText={
                    errorDate
                      ? translate(messages.hearingDateError, props)
                      : dateStringToLocalDate(
                          get(civilProceedingInfo, [
                            CIVIL_PROCEEDING_LAWYER_INFORMATIONS_FIELDS.HEARING_DATE,
                          ]) as any,
                        ) === 'Invalid date'
                      ? translate(messages.invalidDate, props)
                      : ''
                  }
                />
              </MuiPickersUtilsProvider>
            </Grid>
            <Grid item xs={4}>
              <TextField
                id="judgement_number_field"
                label={translate(messages.circomscriptionField, props)}
                onChange={handleChange(
                  CIVIL_PROCEEDING_LAWYER_INFORMATIONS_FIELDS.CIRCUMSCRIPTION,
                )}
                className="input"
                name={
                  CIVIL_PROCEEDING_LAWYER_INFORMATIONS_FIELDS.CIRCUMSCRIPTION
                }
                value={get(civilProceedingInfo, [
                  CIVIL_PROCEEDING_LAWYER_INFORMATIONS_FIELDS.CIRCUMSCRIPTION,
                ])}
              />
            </Grid>
            <Grid item xs={4}>
              <FormControl className="input">
                <InputLabel id="idd-label-id">
                  {translate(messages.jurisdictionField, props)}
                </InputLabel>
                <Select
                  labelId="idd-label-id"
                  onChange={handleChange(
                    CIVIL_PROCEEDING_LAWYER_INFORMATIONS_FIELDS.DEGREE_OF_JURISDICTION,
                  )}
                  name={
                    CIVIL_PROCEEDING_LAWYER_INFORMATIONS_FIELDS.DEGREE_OF_JURISDICTION
                  }
                  value={get(civilProceedingInfo, [
                    CIVIL_PROCEEDING_LAWYER_INFORMATIONS_FIELDS.DEGREE_OF_JURISDICTION,
                  ])}
                >
                  {get(props.listings, 'jurisdictionDegrees', []).map(
                    (element: { id: number; title: string }) => (
                      <MenuItem value={element.id}>{element.title}</MenuItem>
                    ),
                  )}
                </Select>
              </FormControl>
            </Grid>
          </Grid>
        </CustomBloc>

        <CustomBloc
          title={translate(messages.supportingDocuments, props)}
          icon={<RequestIcon width="19" height="25" />}
        >
          <Grid container direction="row" spacing={2}>
            <Grid item xs={6}>
              <UploadDocumentBloc
                index={0}
                title={translate(messages.citation, props)}
                document={civilProceedingInfoDoc}
                resetUploadedDocument={props.resetUploadedDocument}
                uploadDocument={props.uploadDocument}
                uploadedDocument={props.uploadedDocument}
                docType={DOCUMENT_TYPES.CIVIL_PROCEEDING}
                setDocumentId={props.setDocumentId}
                setDocument={setDocumentCivilProceeding}
                shouldDisplay={false}
                docId={DOC_ID_CITATION}
              />
            </Grid>

            <Grid item xs={6}>
              <UploadDocumentBloc
                index={1}
                title={translate(messages.request, props)}
                document={civilProceedingRequestDoc}
                resetUploadedDocument={props.resetUploadedDocument}
                uploadDocument={props.uploadDocument}
                uploadedDocument={props.uploadedDocument}
                docType={DOCUMENT_TYPES.CIVIL_PROCEEDING_REQUEST}
                setDocumentId={props.setDocumentId}
                setDocument={setDocumentID}
                shouldDisplay={false}
                docId={DOC_ID_REQUEST}
              />
            </Grid>
          </Grid>
        </CustomBloc>
      </Grid>
    </FormContainer>
  );
};

export default injectIntl(CivilProceedingForm);
